import {getCourseGradeLabel, getCourseTimeLabel, getSubjectName, getTeacherName} from '../../utils/academy.js';
import {classificationLabel} from '../../utils/courseTerms.js';
import {timetableTermType} from '../../utils/timetableTerms.js';
const order={first_semester:1,summer_intensive:2,second_semester:3,winter_intensive:4};
export const enrollmentTermKey=course=>JSON.stringify([String(course.year||''),course.term||course.semester||'']);
export function enrollmentCourseLabel(course,subjects,teachers){
 return [getCourseGradeLabel(course),getSubjectName(subjects,course.subjectId,course.subject||'과목 미지정'),course.className||'반 미지정',getCourseTimeLabel(course),getTeacherName(teachers,course.teacherId,'선생님 미지정')].filter(Boolean).join(' · ');
}
export function enrollmentCourseTerms(courses,terms=[],selectedId=''){
 const available=courses.filter(c=>c.active!==false||c.id===selectedId);
 const groups=new Map();
 for(const course of available){
  const key=enrollmentTermKey(course);if(groups.has(key))continue;
  const type=timetableTermType(course,terms);
  const term=terms.find(t=>(t.id||t.value)===(course.term||course.semester));
  const label=type?classificationLabel(type):(term?.label||course.termLabel||'학기 미지정');
  const year=String(course.year||'');
  const caption=year&&label.startsWith(year)?label:`${year?year+'년 ':''}${label}`;
  groups.set(key,{value:key,label:caption,year:Number(year)||0,rank:order[type]||0});
 }
 return [...groups.values()].sort((a,b)=>b.year-a.year||b.rank-a.rank||a.value.localeCompare(b.value));
}
